import {SAVE_LOCATION_SITE, SAVE_LOCATION_ENTITY} from 'common/types';
import ApiActions from 'go/actions/api';
import {call, take, select, fork, put} from 'redux-saga/effects';
import _ from 'lodash';

// TODO, what is this for? What is this saga doing that isn't already in a reducer?
export default function* saveLocationDataSaga() {
  const action = yield take([SAVE_LOCATION_SITE, SAVE_LOCATION_ENTITY]);
  yield fork(saveFromReduxStateToService, action);
  yield call(saveLocationDataSaga);
}

// does the redux interaction for all methods below
export function* saveFromReduxStateToService(action) {
  const state = yield select();
  const token = _.get(state, 'auth.token');
  const payload = _.get(state, 'locationSiteData.inventoryItem');
  return put(ApiActions.location.updateProjectSiteDetails(token, payload));
}
